import React, { useRef } from 'react'
import { Link } from 'react-router-dom'

const LongQuestions = () => {

  const scollToRef = useRef();
  const scollToRef1 = useRef();

  return (
    <>
      <section className="ahsec_banner">
        <div className="container h-100">
          <div className="row h-100">
            <div
              className="col-md-12 h-100"
              data-aos="fade-up"
              data-aos-duration="3000"
            >
              <div className="ahsec_title">
                <p>Long Questions</p>
                <h1>AHSEC</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="first_main">
        <section className="first_year my-5">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div
                  className="first_year_info text-center"
                  data-aos="fade-right"
                  data-aos-duration="3000"
                >
                  <p>Select Your Class/Standard Here :</p>
                  <div className="button_div">
                    <button className="btn btn-primary mx-2" onClick={() => scollToRef.current.scrollIntoView({behavior:"smooth"})}>
                      <div className="button-inner">Class 11 (First year)</div>
                    </button>
                    <button className="btn btn-primary" onClick={()=>scollToRef1.current.scrollIntoView()}>
                      <div className="button-inner">Class 12 (Second year)</div>
                    </button>
                  </div>
                </div>
                <div className="divider" ref={scollToRef}></div>
              </div>
            </div>
            <div className="row"  data-aos="fade-left"
              data-aos-duration="3000">
              <div className="first_year_acc text-center d-block">
                <div className="advanced-heading-content">
                  <div class="">Class 11</div>
                </div>
                <div className="sub-heading">
                  <div className="sub-heading-content">
                    Previous Year Question Papers for Assam Higher Secondary
                  </div>
                </div>
                <h2 className="heading-title">
                  <div className="main-heading">
                    <div className="main-heading-inner">H.S. First Year</div>
                  </div>
                </h2>
              </div>
            </div>
          </div>
        </section>
        <section class="Faq py-1 my-1">
          <div class="container">
            <div class="headingblack text-center mb-2 pb-2">
              <h5>commerce</h5>
            </div>
            <div class="row">
              <div class="">
                <div class="accordion" id="myAccordion">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button
                        type="button"
                        class="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                      >
                        Accountancy
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      class="accordion-collapse collapse"
                      data-bs-parent="#myAccordion"
                    >
                      <div class="card-body">
                        <ul>
                          <li><Link>Issue And Redemption Of Debentures</Link></li>
                          <li><Link>Partnership</Link></li>
                          <li><Link>Financial Statement</Link></li>
                          <li><Link>Accounting Ratios</Link></li>
                          <li><Link>Accounting For Not For Profit Orgainsation</Link></li>
                          <li><Link>Cash Flow Statements</Link></li>
                          <li><Link>Accounting For Share Capitals</Link></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwo">
                      <button
                        type="button"
                        class="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                      >
                        Banking
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      class="accordion-collapse collapse"
                      data-bs-parent="#myAccordion"
                    >
                      <div class="card-body">
                      <ul>
                          <li><Link>Reserve Bank Of India</Link></li>
                          <li><Link>Non Bank Financial Institutions</Link></li>
                          <li><Link>Negotiable Instrument</Link></li>
                          <li><Link>Financial Market</Link></li>
                          <li><Link>Employement of Funds</Link></li>
                          <li><Link>Commercial Banking In India</Link></li>
                          <li><Link>Cheque</Link></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThree">
                      <button
                        type="button"
                        class="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                      >
                        Business Studies
                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      class="accordion-collapse collapse"
                      data-bs-parent="#myAccordion"
                    >
                      <div class="card-body">
                      <ul>
                          <li><Link>Nature And Significance of Management</Link></li>
                          <li><Link>Principles of Managemnet</Link></li>
                          <li><Link>Business Environment</Link></li>
                          <li><Link>Planning</Link></li>
                          <li><Link>Organising</Link></li>
                          <li><Link>Directing</Link></li>
                          <li><Link>Staffing</Link></li>
                          <li><Link>Controlling</Link></li>
                          <li><Link>Financial Market</Link></li>
                          <li><Link>Marketing</Link></li>
                          <li><Link>Consumer Protection</Link></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFour">
                      <button
                        type="button"
                        class="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour"
                      >
                        Economics
                      </button>
                    </h2>
                    <div
                      id="collapseFour"
                      class="accordion-collapse collapse"
                      data-bs-parent="#myAccordion"
                    >
                      <div class="card-body">
                      <ul>
                          <li><Link>Introductions</Link></li>
                          <li><Link>National Income And Accounting</Link></li>
                          <li><Link>Money And Banking</Link></li>
                          <li><Link>Determinations Of Income And Employement</Link></li>
                          <li><Link>Governemnet Budget And The Economy</Link></li>
                          <li><Link>Open Economy-macroeconomics</Link></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingSix">
                      <button
                        type="button"
                        class="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSix"
                      >
                        Alternative English
                      </button>
                    </h2>
                    <div
                      id="collapseSix"
                      class="accordion-collapse collapse"
                      data-bs-parent="#myAccordion"
                    >
                      <div class="card-body">
                      <ul>
                          <li><Link>Village Song</Link></li>
                          <li><Link>The Verger</Link></li>
                          <li><Link>The Scarecrow</Link></li>
                          <li><Link>The Gift of The Magi</Link></li>
                          <li><Link>The Brook</Link></li>
                          <li><Link>Testament of A Walker</Link></li>
                          <li><Link>Sita</Link></li>
                          <li><Link>Ozymandias Of Egypt</Link></li>
                          <li><Link>La Bella Dams Sans Merci</Link></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="button_div text-center bottom_div_button my-3">
            <button className="btn btn-primary mx-2">
              <div className="button-inner">
                Need Long Questions?
                <i class="fas fa-long-arrow-right mx-2"></i> Click Here
              </div>
            </button>
          </div>
        </section>
      </div>
      <div className="second_main" ref={scollToRef1}>
        <section className="first_year">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="divider"></div>
              </div>
            </div>
            <div className="row">
              <div className="first_year_acc text-center d-block">
                <div className="advanced-heading-content">
                  <div class="">Class 12</div>
                </div>
                <div className="sub-heading">
                  <div className="sub-heading-content">
                    Previous Year Question Papers for Assam Higher Secondary
                  </div>
                </div>
                <h2 className="heading-title">
                  <div className="main-heading">
                    <div className="main-heading-inner">H.S. Second Year</div>
                  </div>
                </h2>
              </div>
            </div>
          </div>
        </section>
        <section class="Faq py-1 my-1">
          <div class="container">
            <div class="headingblack text-center mb-2 pb-2">
              <h5>commerce</h5>
            </div>
            <div class="row">
              <div class="">
                <div class="accordion" id="myAccordion">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingSeven">
                      <button
                        type="button"
                        class="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSeven"
                      >
                        Accountancy
                      </button>
                    </h2>
                    <div
                      id="collapseSeven"
                      class="accordion-collapse collapse"
                      data-bs-parent="#myAccordion"
                    >
                      <div class="card-body">
                      <ul>
                          <li><Link>Nature And Significance of Management</Link></li>
                          <li><Link>Principles of Managemnet</Link></li>
                          <li><Link>Business Environment</Link></li>
                          <li><Link>Planning</Link></li>
                          <li><Link>Organising</Link></li>
                          <li><Link>Directing</Link></li>
                          <li><Link>Staffing</Link></li>
                          <li><Link>Controlling</Link></li>
                          <li><Link>Financial Market</Link></li>
                          <li><Link>Marketing</Link></li>
                          <li><Link>Consumer Protection</Link></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingEight">
                      <button
                        type="button"
                        class="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseEight"
                      >
                        Banking
                      </button>
                    </h2>
                    <div
                      id="collapseEight"
                      class="accordion-collapse collapse"
                      data-bs-parent="#myAccordion"
                    >
                      <div class="card-body">
                      <ul>
                          <li><Link>Nature And Significance of Management</Link></li>
                          <li><Link>Principles of Managemnet</Link></li>
                          <li><Link>Business Environment</Link></li>
                          <li><Link>Planning</Link></li>
                          <li><Link>Organising</Link></li>
                          <li><Link>Directing</Link></li>
                          <li><Link>Staffing</Link></li>
                          <li><Link>Controlling</Link></li>
                          <li><Link>Financial Market</Link></li>
                          <li><Link>Marketing</Link></li>
                          <li><Link>Consumer Protection</Link></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingNine">
                      <button
                        type="button"
                        class="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseNine"
                      >
                        Business Studies
                      </button>
                    </h2>
                    <div
                      id="collapseNine"
                      class="accordion-collapse collapse"
                      data-bs-parent="#myAccordion"
                    >
                      <div class="card-body">
                      <ul>
                          <li><Link>Nature And Significance of Management</Link></li>
                          <li><Link>Principles of Managemnet</Link></li>
                          <li><Link>Business Environment</Link></li>
                          <li><Link>Planning</Link></li>
                          <li><Link>Organising</Link></li>
                          <li><Link>Directing</Link></li>
                          <li><Link>Staffing</Link></li>
                          <li><Link>Controlling</Link></li>
                          <li><Link>Financial Market</Link></li>
                          <li><Link>Marketing</Link></li>
                          <li><Link>Consumer Protection</Link></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTen">
                      <button
                        type="button"
                        class="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTen"
                      >
                        Economics
                      </button>
                    </h2>
                    <div
                      id="collapseTen"
                      class="accordion-collapse collapse"
                      data-bs-parent="#myAccordion"
                    >
                      <div class="card-body">
                      <ul>
                          <li><Link>Nature And Significance of Management</Link></li>
                          <li><Link>Principles of Managemnet</Link></li>
                          <li><Link>Business Environment</Link></li>
                          <li><Link>Planning</Link></li>
                          <li><Link>Organising</Link></li>
                          <li><Link>Directing</Link></li>
                          <li><Link>Staffing</Link></li>
                          <li><Link>Controlling</Link></li>
                          <li><Link>Financial Market</Link></li>
                          <li><Link>Marketing</Link></li>
                          <li><Link>Consumer Protection</Link></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingEleven">
                      <button
                        type="button"
                        class="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseEleven"
                      >
                        English
                      </button>
                    </h2>
                    <div
                      id="collapseEleven"
                      class="accordion-collapse collapse"
                      data-bs-parent="#myAccordion"
                    >
                      <div class="card-body">
                      <ul>
                          <li><Link>Nature And Significance of Management</Link></li>
                          <li><Link>Principles of Managemnet</Link></li>
                          <li><Link>Business Environment</Link></li>
                          <li><Link>Planning</Link></li>
                          <li><Link>Organising</Link></li>
                          <li><Link>Directing</Link></li>
                          <li><Link>Staffing</Link></li>
                          <li><Link>Controlling</Link></li>
                          <li><Link>Financial Market</Link></li>
                          <li><Link>Marketing</Link></li>
                          <li><Link>Consumer Protection</Link></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwelve">
                      <button
                        type="button"
                        class="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwelve"
                      >
                        Alternative English
                      </button>
                    </h2>
                    <div
                      id="collapseTwelve"
                      class="accordion-collapse collapse"
                      data-bs-parent="#myAccordion"
                    >
                      <div class="card-body">
                      <ul>
                          <li><Link>Nature And Significance of Management</Link></li>
                          <li><Link>Principles of Managemnet</Link></li>
                          <li><Link>Business Environment</Link></li>
                          <li><Link>Planning</Link></li>
                          <li><Link>Organising</Link></li>
                          <li><Link>Directing</Link></li>
                          <li><Link>Staffing</Link></li>
                          <li><Link>Controlling</Link></li>
                          <li><Link>Financial Market</Link></li>
                          <li><Link>Marketing</Link></li>
                          <li><Link>Consumer Protection</Link></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="button_div text-center bottom_div_button my-3">
            <button className="btn btn-primary mx-2">
              <div className="button-inner">
                Need Long Questions?
                <i class="fas fa-long-arrow-right mx-2"></i> Click Here
              </div>
            </button>
          </div>
          <div className="divider"></div>
        </section>
      </div>
      <section className="college_intro">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="intro_inner">
                <div className="content">
                  <h2 className="my-2">
                    About Assam Higher Secondary Education Council (AHSEC)
                  </h2>
                  <p className="my-4">
                    AHSEC an acronym for Assam Higher Secondary Education
                    Council is a board of education under the&nbsp;state
                    government of Assam. It is the regulating body for higher
                    secondary (10+2 stage) education in the state of
                    Assam.&nbsp; The Assam Higher Secondary Education Council
                    was established by the Assam government on 1 June 1984 to
                    regulate, supervise and develop the system of higher
                    secondary education in the State of Assam.
                  </p>
                </div>
                <div className="content mt-5">
                  <h5 className="my-2">
                    Functions Of Assam Higher Secondary Education Council
                  </h5>
                  <p className="my-4">
                    One of the main operations of the AHSEC (Assam Higher
                    Secondary Education Council) is to enforce the rules and
                    regulations, that have been set for the schools that are
                    affiliated with the Assam Board. Other functions also
                    include prescribing the syllabus, devising courses of study
                    like the textbooks, conducting exams and so on.
                  </p>
                </div>
                <div className="content mt-5">
                  <h5 className="my-2">
                    Exam Conducted by Assam Higher Secondary Education Council
                  </h5>
                  <p className="my-4">
                    The Assam Higher Secondary Education Council conducts Class
                    12 exam every year.&nbsp;AHSEC or the Assam Higher Secondary
                    Education Council supervises, regulates, and develops the
                    system of 12th standard in the state. The 12th standard
                    exams in Assam are conducted for Science, Commerce, Arts and
                    Vocational Groups.
                  </p>
                </div>
                <div className="content mt-5">
                  <h5 className="my-2">About Previous Year Question Papers</h5>
                  <p className="my-3">
                    As of 2014, the Assam Higher Secondary Education Council has
                    adopted the NCERT curriculum for class 12 students.
                    Therefore the exams are also held in the NCERT pattern. The
                    board has further stated that by adopting such curriculum it
                    will bring greater benefit to the students as they will be
                    on par with students from other boards. However, class 12
                    exams are very important for students as the results they
                    obtain will determine the careers they choose in the future.
                  </p>
                  <p className="my-3 pe-4">
                    Therefore, students need to prepare well for the exam. Apart
                    from studying from the&nbsp;Assam Board textbooks, another
                    way student can study productively is by practising and
                    solving question papers. Students can further use and solve
                    question papers to know how the entire exam paper will be
                    set. Additionally, by making use of question papers,
                    students will;
                  </p>
                  <ul className="my-3">
                    <li>
                      Understand clearly how the exam paper pattern will be.
                    </li>
                    <li>
                      Know the repeated topics and what to focus on while
                      studying.
                    </li>
                    <li>Learn about the marking scheme.</li>
                    <li>Figure out the time needed to solve each question.</li>
                  </ul>
                  <p>
                    Students can access a set of Assam board class 12 question
                    papers below and refer them to test their preparation level
                    as well get an idea about the types of questions that are
                    asked in each subject. These question papers will serve a
                    great purpose of helping students prepare well for the board
                    exams.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default LongQuestions